export const UPDATE_OFFICE = 'REAL_ESTATE_OFFICE/UPDATE';
export const UPDATE_OFFICE_STAFF_MEMBERS = 'REAL_ESTATE_OFFICE/UPDATE_STAFF_MEMBERS';
export const CREATE_AGENT = 'REAL_ESTATE_OFFICE/CREATE_AGENT';
export const UPDATE_AGENT = 'REAL_ESTATE_OFFICE/UPDATE_AGENT';
